module.exports = __webpack_public_path__ + "static/media/empty.babf4d08.svg";